import React from "react";

// Web version of FadeOut.js: the text blurs more toward the bottom (a backdrop
// blur masked by a gradient) while it fades into `color`.
export default function FadeOut({ height = 72, color = "#FFFFFF", style }) {
  const box = {
    position: "absolute",
    left: 0,
    right: 0,
    bottom: 0,
    height,
    pointerEvents: "none",
  };
  const mask = "linear-gradient(to bottom, transparent 15%, #000 85%)";
  return (
    <div aria-hidden="true" style={{ ...box, ...flatten(style) }}>
      <div
        style={{
          ...box,
          backdropFilter: "blur(3px)",
          WebkitBackdropFilter: "blur(3px)",
          maskImage: mask,
          WebkitMaskImage: mask,
        }}
      />
      <div
        style={{
          ...box,
          background: `linear-gradient(to bottom, ${hexToRgba(
            color,
            0
          )} 0%, ${hexToRgba(color, 0.75)} 55%, ${color} 100%)`,
        }}
      />
    </div>
  );
}

const flatten = (style) =>
  Array.isArray(style)
    ? Object.assign({}, ...style.filter(Boolean))
    : style || {};

// "transparent" in a gradient fades through grey in some browsers; fade the
// same colour's alpha instead.
function hexToRgba(hex, alpha) {
  const m = /^#?([0-9a-f]{6})$/i.exec(hex);
  if (!m) return alpha === 0 ? "transparent" : hex;
  const n = parseInt(m[1], 16);
  return `rgba(${(n >> 16) & 255}, ${(n >> 8) & 255}, ${n & 255}, ${alpha})`;
}
